import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  fundsService: service(),
  navbarSettings: service(),
  storeCache: service(),

  beforeModel() {
    return this.fundsService.confirmValidFundToken();
  },

  model() {
    let fundModel = this.modelFor('admin.funds.fund');
    let fundId = get(fundModel, 'record.id');
    set(this, 'navbarSettings.title', get(fundModel, 'record.name'));
    return this.storeCache.findAll('admin/fund-group').then((fundGroups) => {
      let associatedFundGroups = fundGroups.filter((fundGroup) => {
        return get(fundGroup, `fundIdKeys.${fundId}`);
      });
      return Object.assign(
        {
          fundGroups: associatedFundGroups,
        },
        fundModel,
      );
    });
  },
});
